//import Components
import {Col, Row, Navbar} from "reactstrap";
import {NavLink} from "react-router-dom";
import PropTypes from "prop-types";


//import icons
import UserButton from "./components/UserButton";
import MenuButton from "./components/MenuButton";

//import media
import navLogoMin from "../../../media/images/logos/Logo.png";
import navLogo from "../../../media/images/logos/LOGO_Svart_Org.png"

TopNav.propTypes = {
    className: PropTypes.string
}

export default function TopNav ({sideNavState, className}) {
    const [open] = sideNavState;
    return (
        <>
            <Navbar className={className + " row nowrap"} container={false}>
                <Col md="auto" className={"topNav_side"}>
                    <NavLink
                        className={"topNav_logo"}
                        to={"/"}>
                        <img className={open && "hidden"} src={navLogoMin} alt="Billett.no logo"/>
                        <img className={!open && "hidden"} src={navLogo} alt="Billett.no logo"/>
                    </NavLink>
                </Col>
                <Row className={"topNav_main nowrap"} sm={"fill"}>
                    <Col className={"topNavMain_left"} xs={"auto"}>
                        <MenuButton state={sideNavState}/>
                    </Col>
                    <Col className={"topNavMain_right"} xs={"fill"}>
                        <UserButton/>
                    </Col>
                </Row>
            </Navbar>
        </>
    )
}
